import React, { Component } from "react"
import { Col } from "react-bootstrap"
import { connect } from "react-redux"
import Measure from "react-measure"
import _ from "lodash"
import Socket from "../../lib/socket"
import constants from "../../lib/constants"
import GlobalValues from "../../lib/values"
import { formatGameIdentifier } from "../../lib/helper"
import { CustomAlert } from "../common"
import QuestionsWindow from "../questionsWindow/view"
import SegmentWindow from "../segmentWindow/view"
import { BiFullscreen } from "react-icons/bi"

// Actions
import {
  gameUpdate,
  joinGame,
  gameJumpForeplay,
} from "../../../src/entities/game/actions"
import {
  updateAlertMessage,
  updateCurrentSegment,
  gameUpdateStage,
} from "../../../src/entities/ui/actions"

import startBanner from "../../../src/assets/startBanner.jpg"
import logoImage from "../../../src/assets/logo.png"
import playStore from "../../../src/assets/play.png"
import appStore from "../../../src/assets/appstore.png"

// Styles
import "./styles/startWindowStyles.css"
import "../../../src/styles/styles.css"

// static variables
let intervalId
let initialSocketSetup = false

const INTERVAL_FOREPLAY = 45000
const INTERVAL_JOINGAME = 15000

class StartWindow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dimensions: {
        height: 0,
        width: 0,
      },
      fullScreenOn: false,
    }

    this.onTextInputChange = this.onTextInputChange.bind(this)
    this.onButtonClick = this.onButtonClick.bind(this)
    this.onGoFullScreenButtonClick = this.onGoFullScreenButtonClick.bind(this)
    this.renderCustomAlert = this.renderCustomAlert.bind(this)
    this.renderJoinGameWindow = this.renderJoinGameWindow.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.setupGame = this.setupGame.bind(this)
    this.switchStartBanner = this.switchStartBanner.bind(this)
    this.goFullScreen = this.goFullScreen.bind(this)
  }

  componentDidMount() {
    // Set up the game if the user has come from a direct URL
    if (this.props.params.gameId) {
      this.setupGame()
    }
  }

  componentWillReceiveProps() {
    if (
      this.props.gameState.game_stage_id === constants.GAME_STAGE_COMMENCING &&
      this.props.gameState.foreplay &&
      this.props.currentForeplayIndex === 0 &&
      !intervalId
    ) {
      intervalId = _.delay(
        this.switchStartBanner,
        this.props.gameStageWindow === "startWindow"
          ? INTERVAL_JOINGAME
          : INTERVAL_FOREPLAY
      )

      if (Socket.isSocket() && !initialSocketSetup) {
        Socket.getSocket().addEventListener("message", (event) => {
          const payload = JSON.parse(event.data) || {}

          if (payload.event === "game_start") {
            clearTimeout(intervalId)
          }

          if (payload.event === "showForeplayResults") {
            // Open Foreplay window in case it's not opened
            this.props.gameUpdateStage({
              stage: "questionsWindow",
            })
            // Clear the interval created in the function setupGame
            clearTimeout(intervalId)
            return
          }

          if (payload.event === "play_jingle") {
            if (this.props.gameStageWindow !== "segmentWindow") {
              this.props.updateCurrentSegment({
                video: GlobalValues.data.game.intro_video,
              })

              this.props.gameUpdateStage({
                stage: "segmentWindow",
              })
            }
            return
          }
        })

        initialSocketSetup = true
      }
    }
  }

  switchStartBanner() {
    intervalId = _.delay(
      this.switchStartBanner,
      this.props.gameStageWindow === "startWindow"
        ? INTERVAL_JOINGAME
        : INTERVAL_FOREPLAY
    )

    if (this.props.gameStageWindow === "startWindow") {
      // Trigger the next foreplay question
      this.props.gameJumpForeplay()

      this.props.gameUpdateStage({
        stage: "questionsWindow",
      })
    } else if (this.props.gameStageWindow === "questionsWindow") {
      this.props.gameUpdateStage({
        stage: "startWindow",
      })
    }
  }

  onButtonClick() {
    this.setupGame()
  }

  onGoFullScreenButtonClick() {
    document.body.requestFullscreen()
    this.setState({ fullScreenOn: true })
  }

  onTextInputChange(text) {
    this.props.gameUpdate({
      prop: "gameIdentifier",
      value: text.target.value.trim().replace(/\D/g, ""),
    })
  }

  setupGame() {
    const { gameId } = this.props.params
    const { gameIdentifier } = this.props

    if (gameIdentifier) {
      this.props.joinGame({
        identifier: gameIdentifier,
      })
      return
    }

    this.props.joinGame({
      game_id: gameId,
    })
  }

  renderCustomAlert() {
    if (this.props.alertMessage) {
      this.msg.show(this.props.alertMessage)
      this.props.updateAlertMessage({ message: "" })
    }
  }

  goFullScreen() {
    if (!this.state.fullScreenOn) {
      return (
        <button
          type="button"
          className="btn btn-fullscreen fontFamilyBold"
          onClick={this.onGoFullScreenButtonClick}
        >
          <BiFullscreen />
        </button>
      )
    }
  }

  renderGameContainer() {
    if (this.props.gameState.game) {
      return (
        <Measure
          onMeasure={(dimensions) => {
            this.setState({ dimensions: dimensions })
          }}
        >
          <div className="bgWhite internalBox withGameId">
            <p className="fontFamilyBold fontColorBlack textCenter stepText">
              1. Download the Sheepoll App
            </p>
            <p className="fontFamilyBold fontColorBlack textCenter stepText">
              2. Create your account
            </p>
            <p className="fontFamilyBold fontColorBlack textCenter stepText">
              3. Join using this code{" "}
              <p className="fontFamilyBold fontColorGreen textCenter gameID">
                {formatGameIdentifier(this.props.gameIdentifier)}
              </p>
            </p>
          </div>
        </Measure>
      )
    }

    return (
      <div className="bgWhite internalBox withoutGameId">
        <h1 className="fontColorBlack fontFamilyBold textCenter joinGameTextStyle">
          NEW GAME
        </h1>
        <Col xs={12} className="mtop60">
          <div className="col-xs-12 gameIdForm p5">
            <input
              id="gameIdentifier"
              type="text"
              placeholder="Type #Game ID"
              className="defaultInput fontFamilyBold col-xs-12 col-md-8"
              value={
                this.props.gameIdentifier
                  ? this.props.gameIdentifier.match(/.{1,3}/g).join("-")
                  : ""
              }
              maxLength={9}
              onChange={this.onTextInputChange}
            />
            <button
              type="button"
              className="btn btn-green fontColorWhite fontFamilyBold col-xs-12 col-md-4"
              style={{ fontSize: "4vh" }}
              onClick={this.onButtonClick}
            >
              JOIN
            </button>
          </div>
        </Col>
      </div>
    )
  }

  renderJoinGameWindow() {
    return (
      <div>
        <Col xs={12} sm={4} className="leftBanner p0">
          <Col xs={12} className="p0">
            <img alt="" src={startBanner} className="banner" />
          </Col>
          <Col xs={12} className="p0 downloadLinks">
            <div className="downloadAppLogoContainer">
              <img alt="" src={logoImage} className="logo" />
            </div>

            <Col xs={12} className="p0 downloadLinksContainer">
              <Col xs={12} sm={6} className="p0 platformLink">
                <div>
                  <img alt="" src={appStore} className="storeImage" />
                  <img alt="" src={playStore} className="storeImage" />
                </div>
                <h4 className="fontFamilyBold textCenter appLinkText">
                  download.sheepoll.com
                </h4>
              </Col>
            </Col>
          </Col>
        </Col>
        <Col xs={12} sm={8} className="rightBanner bgLightGray">
          {this.renderGameContainer()}
        </Col>
      </div>
    )
  }

  renderContent() {
    switch (this.props.gameStageWindow) {
      case "startWindow":
        return this.renderJoinGameWindow()
      case "questionsWindow":
        return <QuestionsWindow />
      case "segmentWindow":
        return <SegmentWindow />
      default:
        return null
    }
  }

  render() {
    return (
      <div className="startWindow">
        {this.renderContent()}
        <CustomAlert reference={(a) => (this.msg = a)} />
        {this.renderCustomAlert()}
        {this.goFullScreen()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    showForeplayResults,
    currentForeplayIndex,
    gameState,
    game_id: gameId,
  } = state.game.currentGame
  const { gameIdentifier } = state.game

  const { alertMessage, gameStageWindow } = state.ui

  return {
    gameId,
    gameIdentifier,
    showForeplayResults,
    currentForeplayIndex,
    gameState,
    alertMessage,
    gameStageWindow,
  }
}

export default connect(mapStateToProps, {
  gameUpdate,
  joinGame,
  updateAlertMessage,
  gameUpdateStage,
  updateCurrentSegment,
  gameJumpForeplay,
})(StartWindow)



// WEBPACK FOOTER //
// ./src/components/startWindow/view.js